import { Message } from "./styles";
import Spinner from "../../containers/Spinner/Spinner";

interface Props {
  loading: boolean;
  searchOptions: {
    exactMatch: boolean;
    query: string;
  };
  error?: string;
  overrideNoItemsMessage?: string;
}

const SearchTableMessage = ({
  loading,
  searchOptions: { query, exactMatch },
  error,
  overrideNoItemsMessage,
}: Props) => {
  return (
    <Message>
      {!query ? (
        loading ? (
          <Spinner size={"4x"} />
        ) : error ? (
          error
        ) : (
          overrideNoItemsMessage ?? "No Items"
        )
      ) : error ? (
        error
      ) : (
        `No ${exactMatch ? "exact matches" : "results"} found for query "${query}"`
      )}
    </Message>
  );
};
export default SearchTableMessage;
